<template>
	<!-- 培训专区 -->
	<div>
		<div class="expert">
			<Breadcrumb></Breadcrumb>
			<div class="boxshow" v-show="$route.meta.showFather">
				<div class="experts flex-1 pad-16 jus-bet">
					<div class="flex-1 jus-bet">
						<div class="left-icon"></div>
						<p>培训专区</p>
					</div>
				</div>
				<div class="pad-16 col-22">
					<div style="margin-bottom: 24px;display: flex;align-items: center;
					justify-content: space-between;" v-for="(item,index) in expertList" :key="index" @click="detail(item.id)">
						<div class="hed-imgs" style="width: 288px;height: 173px;border-radius: 8px;">
							<img :src="item.coverImg" alt="" style="width: 288px;height: 173px;border-radius: 8px;" />
						</div>
						<div style="width: 80%;">
							<div style="width: 80%;" class="flex-1 just-bet mb-8">
								<p class="name-1">{{item.title}}</p>
								<!-- <img :src="item.img" alt="" class="sex-img"> -->
								<!-- <img src="/src/assets/expert/nv.png" alt=""> -->
							</div>
							<div class="flex-1 just-bet mb-8" style="align-items: baseline;">
								<p class="name-2">培训简介:</p>
								<p class="name-3">
									{{item.introduction}}
								</p>
							</div>
							<div class="flex-1 just-bet" style="padding-bottom: 22px;">
								<p class="name-2">培训时间:</p>
								<p class="name-3">
									{{utils.getNowTime(item.createTime)}}
								</p>
							</div>
						</div>

					</div>
					<el-pagination v-show="pageInline.tableTotal>0" @size-change="handleSizeChange"
						@current-change="handleCurrentChange" :page-sizes="pageGroup.sizes" :page-size="pageGroup.size"
						layout="total, sizes, prev, pager, next, jumper" :total="pageInline.tableTotal">
					</el-pagination>
				</div>
			</div>
			<router-view></router-view>
		</div>
		<footers v-show="footersType == 0"></footers>
	</div>
</template>

<script>
	import Breadcrumb from '@/views/Breadcrumb.vue';
	import footers from '@/views/footers.vue';
	import {
		getEliteSchool,
	} from '@/api/famous/api.js';
	export default {
		components: {
			Breadcrumb,
			footers
		},
		data() {
			return {
				footersType: 0,
				expertList: [],
				//分页对象
				pageInline: {
					tableSizes: this.pageGroup.sizes, //显示条数分组
					tableTotal: 10, // 默认数据总数
				},

			}
		},
		created() {

		},
		mounted() {
			this.footersType = this.$route.query.footersType || 0;
			this.getInit();
		},
		methods: {
			getInit() {
				let params = {
					type: 2,
					pageNo: 1,
					pageSize: this.pageGroup.size,
				}
				getEliteSchool(params).then(res => {
						this.expertList = res.data.list;
						this.pageInline.tableTotal = res.data.total;
					})
					.catch(error => {

					});
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			},
			detail(id) {
				this.$router.push({
					name: 'detail',
					params: {
						id: id
					}
				})
			}
		}
	}
</script>

<style scoped>
	.expert {
		padding: 0 19%;
		/* margin-bottom: 100px; */
	}

	.boxshow {
		width: 62vw;
		box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
	}

	.pad-16 {
		padding: 16px;
	}

	.flex-1 {
		display: flex;
		align-items: center;
		/* justify-content: space-between; */
	}

	.experts {
		/* box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
        border-radius: 8px 8px 8px 8px; */
		margin-top: 16px;

	}

	.experts p {
		font-size: 20px;
		color: #222222;
		font-family: font5;
		margin-left: 10px;
	}

	.left-icon {
		width: 6px;
		height: 20px;
		background: #3377FF;
		border-radius: 18px;
	}

	.jus-bet {
		justify-content: space-between;
	}

	.align-1 {
		align-items: center;
	}

	.col-22 {
		color: #222222;

	}

	.hed-imgs {
		width: 288rpx;
		height: 173px;
		margin-right: 30px;
		border-radius: 8px;
		object-fit: fill;
	}

	.hed-imgs img {
		width: 288rpx;
		height: 173px;
	}

	.mb-8 {
		margin-bottom: 8px;
	}

	.name-1 {
		/* max-width: 800px; */
		max-width: 100%;
		font-size: 20px;
		font-family: font5;
		padding-right: 9px;
		padding-top: 35px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.name-2 {
		color: #999999;
		font-size: 14px;
		font-family: font3;
		white-space: nowrap;
		padding-right: 8px;
	}

	.name-3 {
		/* max-width: 700px; */
		font-size: 14px;
		font-family: font3;
		font-weight: normal;
	}

	/deep/.el-pagination {
		text-align: center;
	}

	.footers {
		margin-top: 25px !important;
	}
</style>